module.exports = __webpack_public_path__ + "static/media/reportonce-logo-white.56e68009.svg";